/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('BoardDinghyBookingDialogController', BoardDinghyBookingDialogController);

    BoardDinghyBookingDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'BoardDinghyBooking'];

    function BoardDinghyBookingDialogController ($timeout, $scope, $uibModalInstance, entity, BoardDinghyBooking) {
        var vm = this;

        vm.booking = entity;
        vm.nickname = vm.booking.profile.nickname ? " \"" + vm.booking.profile.nickname + "\"" : "";
        vm.oldBookingStatus = vm.booking.bookingStatus;
        vm.booking.sendNotificationMail = true;
        vm.clear = clear;
        vm.save = save;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            BoardDinghyBooking.update(vm.booking, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            if (vm.isNewBooking) {
                $scope.$emit('askApp:dinghyBookingUpdate', result);
            } else {
                $scope.$emit('askApp:dinghyBookingCreate', result);
            }
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();
